import { types } from "../types/types";

const initialState = {
  flows: [],
  ruleFlows: [],
  flowsModule: [],
  ruleFlowsModule: []
};

export const flowReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FLOW_START_LOADING:
      return {
        ...state,
        flows: action.payload,
        ruleFlows: action.payload
      };

      case types.FLOW_START_LOADING_FULL_MODULE:
      return {
        ...state,
        flowsModule: action.payload,
        ruleFlowsModule: action.payload
      };

      
    default:
      return state;
  }
};
